import { Service, Qualification, Publication, PracticeArea } from '@/lib/index.ts';

export const practiceAreas: PracticeArea[] = [
  {
    title: 'Psychologia i Psychoterapia',
    description: 'Wsparcie w kryzysach, budowanie odporności psychicznej i terapia poznawczo-behawioralna (CBT).',
    iconName: 'Brain'
  },
  {
    title: 'Seksuologia',
    description: 'Konsultacje w zakresie zdrowia seksualnego, relacji i akceptacji własnej płciowości.',
    iconName: 'Heart'
  },
  {
    title: 'Mediacje',
    description: 'Profesjonalne rozwiązywanie sporów sądowych, rodzinnych oraz konfliktów w biznesie.',
    iconName: 'Scale'
  },
  {
    title: 'Biznes i MBA',
    description: 'Doradztwo strategiczne, mentoring dla liderów oraz wsparcie organizacji w procesach zmian.',
    iconName: 'Briefcase'
  }
];

export const services: Service[] = [
  {
    id: 'psychoterapia-cbt',
    title: 'Psychoterapia Poznawczo-Behawioralna',
    shortDescription: 'Skuteczna terapia CBT oparta na dowodach naukowych.',
    fullDescription: 'Psychoterapia poznawczo-behawioralna (CBT) to jedna z najskuteczniejszych metod terapeutycznych, potwierdzona badaniami naukowymi. Pomagam w zmianie destrukcyjnych wzorców myślenia i zachowania.',
    category: 'psychologia',
    iconName: 'Brain',
    benefits: [
      'Skuteczne leczenie depresji i zaburzeń lękowych',
      'Zmiana negatywnych wzorców myślenia',
      'Nauka praktycznych technik radzenia sobie',
      'Krótkoterminowa terapia z mierzalnymi efektami'
    ],
    targetAudience: 'Osoby z depresją, zaburzeniami lękowymi, problemami z samooceną i trudnościami emocjonalnymi.'
  },
  {
    id: 'konsultacje-seksuologiczne',
    title: 'Konsultacje/Terapia Seksuologiczna',
    shortDescription: 'Profesjonalne wsparcie w obszarze seksualności i intymności.',
    fullDescription: 'Konsultacje i terapia seksuologiczna to bezpieczna przestrzeń do rozmowy o seksualności, intymności i problemach w tej sferze. Pracuję z osobami indywidualnymi i parami.',
    category: 'seksuologia',
    iconName: 'Heart',
    benefits: [
      'Rozwiązanie problemów z dysfunkcjami seksualnymi',
      'Poprawa satysfakcji z życia seksualnego',
      'Przezwyciężenie lęków i blokad seksualnych',
      'Budowanie zdrowej komunikacji o potrzebach'
    ],
    targetAudience: 'Osoby i pary doświadczające trudności w sferze seksualnej lub pragnące poprawić jakość życia intymnego.'
  },
  {
    id: 'konsultacje-psychologiczne',
    title: 'Konsultacje Psychologiczne',
    shortDescription: 'Wsparcie psychologiczne w trudnych momentach życia.',
    fullDescription: 'Konsultacje psychologiczne to profesjonalne wsparcie w rozwiązywaniu problemów życiowych, kryzysów i trudnych sytuacji. Pomagam w znalezieniu właściwych rozwiązań i kierunku działania.',
    category: 'psychologia',
    iconName: 'Users',
    benefits: [
      'Wsparcie w kryzysach życiowych',
      'Pomoc w podejmowaniu ważnych decyzji',
      'Rozwój umiejętności radzenia sobie ze stresem',
      'Wzmocnienie zasobów osobistych'
    ],
    targetAudience: 'Osoby przeżywające trudny okres, kryzys lub potrzebujące wsparcia w podejmowaniu decyzji życiowych.'
  },
  {
    id: 'diagnoza-adhd',
    title: 'Diagnoza ADHD',
    shortDescription: 'Profesjonalna diagnostyka ADHD u dorosłych i dzieci.',
    fullDescription: 'Kompleksowa diagnostyka ADHD obejmująca wywiady, testy psychologiczne i obserwację. Pomagam w zrozumieniu objawów i zaplanowaniu odpowiedniego wsparcia.',
    category: 'psychologia',
    iconName: 'Search',
    benefits: [
      'Dokładna diagnostyka objawów ADHD',
      'Profesjonalne narzędzia diagnostyczne',
      'Szczegółowy raport z rekomendacjami',
      'Wsparcie w planowaniu dalszego leczenia'
    ],
    targetAudience: 'Dzieci, młodzież i dorośli z podejrzeniem ADHD oraz ich rodziny szukające odpowiedzi na trudności koncentracji.'
  },

  {
    id: 'mediacje-biznesowe',
    title: 'Mediacje Biznesowe',
    shortDescription: 'Profesjonalne rozwiązywanie sporów biznesowych i handlowych.',
    fullDescription: 'Specjalizuję się w mediacjach sporów biznesowych, konfliktów między wspólnikami oraz negocjacjach handlowych. Łączę wiedzę z psychologii, prawa i MBA.',
    category: 'mediacje',
    iconName: 'Scale',
    benefits: [
      'Zachowanie relacji biznesowych',
      'Oszczędność czasu i kosztów sądowych',
      'Poufność procesu mediacyjnego',
      'Rozwiązania dostosowane do potrzeb biznesu'
    ],
    targetAudience: 'Przedsiębiorcy, wspólnicy firm, zarządy spółek w sporach handlowych.'
  },
  {
    id: 'mediacje-gospodarcze',
    title: 'Mediacje Gospodarcze',
    shortDescription: 'Rozwiązywanie konfliktów w sferze gospodarczej i finansowej.',
    fullDescription: 'Mediacje w sprawach gospodarczych, sporach o należności, umowach handlowych oraz konfliktach między podmiotami gospodarczymi.',
    category: 'mediacje',
    iconName: 'TrendingUp',
    benefits: [
      'Szybkie rozwiązanie sporów finansowych',
      'Elastyczne warunki ugody',
      'Zachowanie tajemnicy handlowej',
      'Kontynuacja współpracy gospodarczej'
    ],
    targetAudience: 'Podmioty gospodarcze, firmy w sporach finansowych, kontrahenci handlowi.'
  },
  {
    id: 'mediacje-cywilne',
    title: 'Mediacje Cywilne',
    shortDescription: 'Mediacje w sprawach cywilnych i konfliktach międzyludzkich.',
    fullDescription: 'Profesjonalne wsparcie w rozwiązywaniu sporów cywilnych, konfliktów sąsiedzkich, spraw spadkowych oraz innych sporów prywatnych.',
    category: 'mediacje',
    iconName: 'Users',
    benefits: [
      'Rozwiązanie konfliktów bez procesu sądowego',
      'Zachowanie prywatności stron',
      'Elastyczne terminy spotkań',
      'Trwałe porozumienia między stronami'
    ],
    targetAudience: 'Osoby prywatne w sporach cywilnych, sąsiedzi, spadkobiercy, strony umów prywatnych.'
  },
  {
    id: 'mediacje-rodzinne',
    title: 'Mediacje Rodzinne',
    shortDescription: 'Wsparcie rodzin w rozwiązywaniu konfliktów i sporach.',
    fullDescription: 'Mediacje rodzinne pomagają w rozwiązywaniu konfliktów między członkami rodziny, ustalaniu kontaktów z dziećmi oraz innych spraw rodzinnych.',
    category: 'mediacje',
    iconName: 'Heart',
    benefits: [
      'Ochrona dobra dzieci',
      'Zachowanie więzi rodzinnych',
      'Zmniejszenie stresu emocjonalnego',
      'Ustalenia dostosowane do potrzeb rodziny'
    ],
    targetAudience: 'Rodzice, małżeństwa, rodziny w kryzysie, osoby w sporach o kontakty z dziećmi.'
  },
  {
    id: 'mediacje-okolorozwodowe',
    title: 'Mediacje Okołorozwodowe',
    shortDescription: 'Profesjonalne wsparcie w procesach rozwodowych i separacyjnych.',
    fullDescription: 'Specjalistyczne mediacje w sprawach rozwodowych, podziału majątku, alimentach oraz ustaleniu opieki nad dziećmi. Pomagam parom przejść przez rozwód w sposób cywilizowany.',
    category: 'mediacje',
    iconName: 'Scale',
    benefits: [
      'Cywilizowany przebieg rozwodu',
      'Ochrona interesów dzieci',
      'Sprawiedliwy podział majątku',
      'Zmniejszenie kosztów prawnych'
    ],
    targetAudience: 'Małżeństwa w trakcie rozwodu, pary planujące separację, rodzice ustalający opiekę nad dziećmi.'
  },

  {
    id: 'mentoring-program',
    title: 'Mentoring',
    shortDescription: 'Indywidualne wsparcie dla liderów i specjalistów.',
    fullDescription: 'Program mentoringu połączający wiedzę z psychologii, biznesu i przywództwa. Wspieram w rozwoju kompetencji, budowaniu pewności siebie i osiąganiu celów zawodowych.',
    category: 'szkolenia',
    iconName: 'Users',
    benefits: [
      'Indywidualne podejście dostosowane do potrzeb',
      'Rozwiązanie konkretnych wyzwań zawodowych',
      'Budowanie pewności siebie i kompetencji przywódczych',
      'Wsparcie w podejmowaniu strategicznych decyzji'
    ],
    businessImpact: [
      'Zwiększenie efektywności liderów o 40%',
      'Poprawa zaangażowania zespołu',
      'Redukcja rotacji kadry zarządzającej',
      'Lepsze wyniki finansowe działów'
    ],
    targetAudience: 'Liderzy, menedżerowie, specjaliści pragnacy rozwijać swoje kompetencje i karierę.'
  },
  {
    id: 'resilience-design',
    title: 'Szkolenie Resilience Design',
    shortDescription: 'Budowanie odporności psychicznej w organizacji.',
    fullDescription: 'Innowacyjne szkolenie łączące psychologię pozytywną, neurobiologię i design thinking. Uczestnicy uczą się projektować odporność w sobie i swoich zespołach.',
    category: 'szkolenia',
    iconName: 'Award',
    benefits: [
      'Nauka technik budowania odporności na stres',
      'Rozwiązywanie problemów w sposób kreatywny',
      'Wzmocnienie radzenia sobie z niepewnością',
      'Praktyczne narzędzia do codziennego użytku'
    ],
    businessImpact: [
      'Redukcja absencji chorobowej o 30%',
      'Zwiększenie produktywności zespołów',
      'Lepsza adaptacja do zmian organizacyjnych',
      'Zmniejszenie kosztów związanych ze stresem'
    ],
    targetAudience: 'Zespoły projektowe, dzialy HR, liderzy odpowiedzialni za zmiany organizacyjne.'
  },
  {
    id: 'agile-leader-expert',
    title: 'The Agile Leader-Expert',
    shortDescription: 'Przywództwo w świecie ciągłych zmian.',
    fullDescription: 'Zaawansowane szkolenie dla liderów pracujących w dynamicznych środowiskach. Łączy metodyki Agile z psychologią przywództwa i zarządzaniem zmianą.',
    category: 'szkolenia',
    iconName: 'TrendingUp',
    benefits: [
      'Opanowanie technik zwinnego przywództwa',
      'Efektywne zarządzanie zespołami zdalnymi',
      'Budowanie kultury innowacji i eksperymentowania',
      'Rozwiązywanie konfliktów w zespołach Agile'
    ],
    businessImpact: [
      'Skrócenie czasu realizacji projektów o 25%',
      'Zwiększenie jakości dostarczanych rozwiązań',
      'Poprawa komunikacji między działami',
      'Wzrost satysfakcji klientów wewnętrznych'
    ],
    targetAudience: 'Scrum Masterzy, Product Ownerzy, liderzy zespołów IT, menedżerowie projektów.'
  },
  {
    id: 'leadership-resilience-ai',
    title: 'Leadership Resilience in the Age of AI',
    shortDescription: 'Przywództwo w erze sztucznej inteligencji.',
    fullDescription: 'Przygotowanie liderów na wyzwania związane z integracją AI w biznesie. Połączenie wiedzy o technologii z psychologią zmian i przywództwem.',
    category: 'szkolenia',
    iconName: 'Brain',
    benefits: [
      'Zrozumienie wpływu AI na zespoły i procesy',
      'Strategie adaptacji do technologicznych zmian',
      'Budowanie zaufania w środowisku AI-human',
      'Etyczne aspekty wdrażania sztucznej inteligencji'
    ],
    businessImpact: [
      'Szybsza adopcja technologii AI w organizacji',
      'Redukcja oporu wobec zmian technologicznych',
      'Zwiększenie ROI z inwestycji w AI o 35%',
      'Lepsze wykorzystanie potencjału ludzko-maszynowego'
    ],
    targetAudience: 'C-level executives, dyrektorzy IT, liderzy transformacji cyfrowej, menedżerowie innowacji.'
  },

];

export const qualifications: Qualification[] = [
  {
    id: 'q1',
    year: '2026',
    title: 'Doktorat w Instytucie Psychologii (w trakcie)',
    institution: 'Polska Akademia Nauk Instytut Psychologii',
    description: 'Badania nad psychologią kliniczną i społeczną.',
    category: 'academic'
  },
  {
    id: 'q2',
    year: '2025',
    title: 'Master of Business Administration (MBA)',
    institution: 'National Louis University',
    description: 'Skupienie na psychologii zarządzania i etyce biznesu.',
    category: 'academic'
  },
  {
    id: 'q2b',
    year: '2024',
    title: 'Psychologia Biznesu',
    institution: 'SWPS Uniwersytet Humanistycznospołeczny',
    description: 'Specjalizacja w psychologii organizacji, przywództwa i zarządzania zasobami ludzkimi.',
    category: 'academic'
  },
  {
    id: 'q3',
    year: '2024',
    title: 'Prawo',
    institution: 'Wydział Prawa i Administracji',
    description: 'Specjalizacja w mediacjach i prawie rodzinnym.',
    category: 'academic'
  },
  {
    id: 'q4',
    year: '2023',
    title: 'Psychoterapeuta CBT (w trakcie certyfikacji)',
    institution: 'Szkoła Psychoterapii Poznawczo-Behawioralnej',
    category: 'certification'
  },
  {
    id: 'q5',
    year: '2022',
    title: 'Mediator Sądowy i Biznesowy',
    institution: 'Centrum Mediacji',
    description: 'Wpis na listę stałych mediatorów sądowych.',
    category: 'professional'
  },
  {
    id: 'q6',
    year: '2021',
    title: 'Psychologia',
    institution: 'SWPS Uniwersytet Humanistycznospołeczny',
    description: 'Studia magisterskie z psychologii klinicznej.',
    category: 'academic'
  },
  {
    id: 'q7',
    year: '2020',
    title: 'Seksuologia',
    institution: 'Warszawski Uniwersytet Medyczny',
    description: 'Studia podyplomowe z seksuologii klinicznej.',
    category: 'academic'
  },
  {
    id: 'q8',
    year: '2019',
    title: 'Mediacje w organizacji i w biznesie',
    institution: 'SWPS Uniwersytet Humanistycznospołeczny',
    description: 'Specjalistyczne szkolenie z mediacji biznesowych.',
    category: 'certification'
  }
];

export const publications: Publication[] = [
  {
    id: 'p1',
    title: 'Psychologia Zmiany: Między Gabinetem a Biznesem',
    year: '2025',
    type: 'ksiazka',
    publisher: 'Wydawnictwo Naukowe',
    description: 'Kompleksowe spojrzenie na procesy psychologiczne zachodzące w życiu prywatnym i zawodowym.'
  },
  {
    id: 'p2',
    title: 'Wpływ przemocy seksualnej na ścieżki zawodowe kobiet',
    year: '2026',
    type: 'artykul',
    publisher: 'Journal of Psychology and Business',
    description: 'Analiza barier i mechanizmów wsparcia dla liderek po traumatycznych doświadczeniach.'
  },
  {
    id: 'p3',
    title: 'Mediacja jako narzędzie ochrony kapitału relacyjnego',
    year: '2025',
    type: 'konferencja',
    description: 'Wystąpienie podczas Międzynarodowej Konferencji Mediacji Gospodarczych.'
  },
  {
    id: 'p4',
    title: 'Zdrowie psychiczne w świecie MBA',
    year: '2026',
    type: 'media',
    publisher: 'Business Insider',
    description: 'Cykl artykułów eksperckich o higienie psychicznej kadry zarządzającej.'
  }
];